import { Col, Container, Row } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import Layout from "../components/Layout";
import { useDispatch, useSelector } from "react-redux";
import { startstopLoading } from "../Redux/Reducers/globalSlice";
import { useEffect } from "react";
import { getFeedBackData } from "../Redux/Actions/feedBackData";
import NoData from "../components/NoData";
import { formatDateToDMY } from "../Utils/commonFiles";
import profile from "../assets/images/place-holder.png";
import Pagination from "../components/Pagination";

export default function Feedbacks() {

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const Image_url = process.env.REACT_APP_IMG_URL + "/uploads/";
  const feedbackList = useSelector((e) => e.feedbackAuth.feedbackDataList);

  useEffect(() => {
    dispatch(startstopLoading(true));
    dispatch(getFeedBackData({ page: 1, limit: 10 })).then((res) => {
      if (res?.payload?.success == true || res?.payload?.success == false) {
        dispatch(startstopLoading(false));
      }
    });
  }, [dispatch]);

    const handlePageClick = (selected) => {
      dispatch(
        getFeedBackData({ page: selected.selected + 1,  limit: 10 })
      );
    };

  return (
    <Layout>
      <Container fluid className="g-0">
        <Row>
          <Col lg={12}>
            <div className="main-title-box">
              <div className="title-head-left">
                <span> Feedback</span>
                <h4>All Feedback Tickets </h4>
              </div>
              <div className="title-pro-right">
                <div className="">
                  <Link to="#" className="waves-effect">
                    <i className="">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
  <g clip-path="url(#clip0_2242_20999)">
    <path d="M19.2905 17.29L18.0005 16V11C18.0005 7.93 16.3605 5.36 13.5005 4.68V4C13.5005 3.17 12.8305 2.5 12.0005 2.5C11.1705 2.5 10.5005 3.17 10.5005 4V4.68C7.63054 5.36 6.00054 7.92 6.00054 11V16L4.71054 17.29C4.08054 17.92 4.52054 19 5.41054 19H18.5805C19.4805 19 19.9205 17.92 19.2905 17.29ZM16.0005 17H8.00054V11C8.00054 8.52 9.51054 6.5 12.0005 6.5C14.4905 6.5 16.0005 8.52 16.0005 11V17ZM12.0005 22C13.1005 22 14.0005 21.1 14.0005 20H10.0005C10.0005 21.1 10.8905 22 12.0005 22Z" fill="#C0C0C0"/>
  </g>
  <defs>
    <clipPath id="clip0_2242_20999">
      <rect width="24" height="24" fill="white"/>
    </clipPath>
  </defs>
</svg>
                    </i>
                  </Link>
                  <img
                    className="align-self-end"
                    src={require("../assets/images/avatar.svg").default}
                  />
                </div>
              </div>
            </div>
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <div class="card min-vh-80">
              <div class="card-body">
                <div class="d-flex justify-content-between align-items-center flex-wrap mb-3 position-relative">
                  <h4 class="title_text">Issues ({feedbackList?.totalFeedbacks || "0"})</h4>
                </div>

                <div class="table-responsive">
                  <table id="" class="table commom-tables nowrap w-100">
                    <thead>
                      <tr>
                        <th className="id-field">#</th>
                        <th className="id-field">Receievd</th>
                        <th className="id-field">Image</th>
                        <th className="id-field">User</th>
                        <th className="id-field">Issue Type </th>
                        {/* <th className="issue-detail id-field">Detail </th>  for more data use this */}
                        <th className="id-field">Detail </th>
                        <th className="id-field">Status</th>
                      </tr>
                    </thead>
                    <tbody class="td_color">

                      {feedbackList?.feedbackList?.length > 0 ? feedbackList?.feedbackList?.map((item, i) => (
                        <tr key={i}>
                        <td>{(feedbackList?.currentPage - 1) * 10 + i + 1}</td>
                          <td>{formatDateToDMY(item?.createdAt)}</td>
                          <td>
                            <img
                              src={
                                item?.user_image
                                  ? item?.user_image?.startsWith(
                                    "uploads/"
                                  )
                                    ? process.env.REACT_APP_IMG_URL +
                                    "/" +
                                    item?.user_image
                                    : Image_url + item?.user_image
                                  : profile
                              }
                              alt=""
                              className="list-image"
                            />
                          </td>
                          <td>@{item?.user_name}</td>
                          <td>{"-"}</td>
                          <td>
                            {item?.comment || "-"}
                          </td>
                          <td>{item?.status == "0" ? "Pending" : "Resolved"}</td>
                        </tr>
                      )) : <NoData />}
                    </tbody>
                  </table>
                  {feedbackList?.totalPages > 1 && (
                    <Pagination
                      handlePageClick={handlePageClick}
                      pageCounttotal={
                        Math.ceil(feedbackList?.totalPages) || 1
                      }
                    />
                  )}
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </Layout>
  );
}
